import styled from 'styled-components';

export const Container = styled.div`
    background-color: rgba(26, 26, 26, 0.8);
    // TODO: Add support for rgba transformation of hex -> rgb
    // background-color: rgba(${({ theme }) => theme.functionColor.function100}, 0.8);
    opacity: 1;
    text-align: center;
    letter-spacing: 0.03em;
    height: 30px;
    margin-left: 0;
    margin-right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ShortenedDelivery = styled.div`
    position: absolute;
    top: 2px;
`;
